import dom from '../../libs/dom';
import GameLoop from '../../libs/GameLoop';
import MainCanvas from './Canvas';
import update from './update';
import addSceneEvents from './SceneEvents';
import addEntities from './entities';

class PipeScene {
  constructor(app) {
    this.app = app;

    const canvasWidth = 150;
    const canvasHeight = document.body.clientHeight;

    this.mainCanvas = new MainCanvas({ width: canvasWidth, height: canvasHeight });

    this.initializeDom();

    this.positionScene();

    addSceneEvents(this);

    // start game loop last
    this.gameLoop = new GameLoop((delta) => {
      update(this, delta);
    });
  }

  initializeDom() {
    this.elContainer = document.querySelector('body');

    this.canvasContainer = dom.make('<div class="canvas-container"></div>');
    this.canvasContainer.appendChild(this.mainCanvas.canvas);

    this.sceneContainer = dom.make('<div class="scene-container"></div>');
    this.sceneContainer.appendChild(this.canvasContainer);

    this.elContainer.appendChild(this.sceneContainer);

    this.sceneContainer.style.top = '60px';
    this.sceneContainer.style.zIndex = '100';

    setTimeout(() => {
      document.body.classList.add('show-scene');
    }, 300);
  }

  positionScene() {
    this.sceneContainer.style.right = 0;

    this.freshStart();
  }

  freshStart() {
    this.entities = null;

    addEntities(this);

    this.camera = {
      focus: { x: 0, y: 0 },
    };
  }
}

export default PipeScene;
